import React, { useState, useEffect, useMemo } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IConfirmVenteReduxProps, IConfirmVenteComponent, ITarget, IVente, IConstante } from '../../types/interfaces';
import { addVente, createPlaceholderDrive, getVenteByIdPromise, uploadRecuAfterVente } from '../../flux/actions/venteActions';
import { getConstanteByID, getConstanteProjetInfos, getConstanteRecuImageIncrem } from '../../flux/actions/constanteActions';
import { getBanks, clearBanks } from '../../flux/actions/bankActions';

import { useAlert } from "react-alert";
import { E_ERROR } from '../../types/errors';
import { constants } from '../../types/constants';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faBuilding, faCheckCircle, faExclamationTriangle, faSpinner} from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import PDFLink, { PreviewBase64, instantPrint, instantUploadToFTP } from '../pdf/PDFLink';
import { PRIVILEGE } from '../../types/privileges';

const ConfirmVente = ({ 
  client,
  // clients,
  bien,
  encaissements,
  association,
  isAssociation,
  setActiveTab,
  switchToBien,
  clearAll,
  selectedProjet,
  userValue,
  numDossier,
  dateVente,
  observation,
  remiseValue,
  remiseTotalValue,
  prixAafficherValue,
  prixAafficherTotalValue,
  addVente,
  getBanks,
  bank,
  auth,
  error
  }: IConfirmVenteComponent) => {
  const PREVIEW = "PREVIEW", CHECK = "CHECK", CONFIRM = "CONFIRM";

  const { banks } = bank;
  const { table_clients } = client;
  const [modal, setModal] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  const [documentModal, setDocumentModal] = useState(false);
  const [previewBase64, setPreviewBase64] = useState({file: '', fileName: ''});
  const [prixBien, setPrixBien] = useState(0);
  const [remiseE, setRemiseE] = useState(0);
  const [prixAafficherE, setPrixAafficherE] = useState(0);
  const [totalEncaissements, setTotalEncaissements] = useState(0);
  const [reliquat, setReliquat] = useState(0);
  
  const handleToggle = () => setModal(!modal);

  const alert = useAlert();

  useEffect(() => {
    getBanks();
  }, [getBanks]);

  useEffect(() => {
    if(bien && remiseValue !== undefined)
      setRemiseE(remiseTotalValue ? remiseValue : (remiseValue * bien.SUPERFICIE))
    else
      setRemiseE(0)
  }, [bien?.SUPERFICIE, remiseValue, remiseTotalValue])

  useEffect(() => {
    if(bien && prixAafficherValue !== undefined)
      setPrixAafficherE(prixAafficherTotalValue ? prixAafficherValue : (prixAafficherValue * bien.SUPERFICIE))
    else
      setPrixAafficherE(0)
  }, [bien?.SUPERFICIE, prixAafficherValue, prixAafficherTotalValue])

  useEffect(() => {
    // if(bien && bien.PRIX_VENTE !== null && bien.PRIX_VENTE !== undefined)
    if((prixAafficherE !== undefined && prixAafficherE > 0) || (bien && bien.PRIX_VENTE !== null && bien.PRIX_VENTE !== undefined))
      setPrixBien((prixAafficherE || bien?.PRIX_VENTE || 0) - (remiseE || 0))
    else
      setPrixBien(0)
  }, [remiseE, prixAafficherE, bien?.PRIX_VENTE])
  // }, [bien?.PRIX_VENTE, remiseE])

  useEffect(() => {
    setTotalEncaissements(encaissements.reduce((e, t) => {
      return t.PART ? e + Number(t.PART) : e
    }, 0))
  }, [encaissements])

  useEffect(() => {
    setReliquat(Number(prixBien) - Number(totalEncaissements))
  }, [prixBien, totalEncaissements])

  const modalClosedHandle = () => {
    if(reEnable){
      // clearDALines();
      // setObservationValue('');
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const callback1 = async (success) => {
    if(success?.vente && !success.err){
      if(success.recuImage){
        let venteTemp = success?.vente
        if(venteTemp && venteTemp.TYPE_VENTE === "ASSOCIATION" && !venteTemp?.PRIX_NET){
          console.log("specialAccess used")
          venteTemp = await getVenteByIdPromise(venteTemp.id || -1, 1)
        }
        else console.log("specialAccess NOT used")
        const constantesProjet = await getConstanteProjetInfos(venteTemp?.IDPROJET || -1, venteTemp?.PROJET || "");
        // 
        const placeholderData = await createPlaceholderDrive(success.recuImage.id, 0, success.recuImage.recu_image_counter, "R", venteTemp?.id || -1, venteTemp?.ID_BIEN || -1, venteTemp?.TYPE_VENTE === "ASSOCIATION" ? 1 : 0, success.recuImage.association_id || undefined, success.recuImage.remise_state, 0, auth?.user?.id)
        if(!placeholderData?.fileId || !placeholderData?.webViewLink || !placeholderData?.recuId){
          alert.error("No placeholder")
          setDisableSubmit(false)
          return
        }
        const recuFile = await instantUploadToFTP({
          documentType: "recu",
          data: {...venteTemp, enc: false/*isAssociation && bien?.contrat*/, addedContratClients: (venteTemp.contrat_clients || []).filter(e => !success.recuImage.association_id || e.ID_ASS == success.recuImage.association_id).map(e => e.client), addedContratEnc: (venteTemp.contrat_encaissements || []).filter(e => !success.recuImage.association_id || e.ID_ASS == success.recuImage.association_id).map(e => ({...e, ...(e.encaissement || {}), bank: banks.find(t => t.id === e.encaissement?.IDBANQUE)})), recu_image_counter: success.recuImage.recu_image_counter, isNewAssociation: venteTemp.TYPE_VENTE === "ASSOCIATION", constantesProjet, webViewLink: placeholderData.webViewLink, authUserId: auth?.user?.id},
          showPreviewWatermark: false,
        });
        const fileData = await uploadRecuAfterVente(success.recuImage.id, venteTemp.id, recuFile, placeholderData.fileId)
        if(fileData)
          callback2({vente: venteTemp, file: fileData.file, fileName: fileData.fileName})
        else
          alert.error("Une erreur s'est produite (2)");
      }
      else
        alert.error("Erreur au niveau de création du reçu de vente")
      return
    }
    if(success?.err?.encExists)
      alert.error("Encaissement(s) déjà saisi(s), ici:", success.err.ventes?.length ? {open: `/consultation/${success.err.ventes[0].id}`, newTab: true, timeout: 5000} : {})
    else if(success?.err?.bienSold)
      alert.error("Bien déjà vendu, ici:", success.err.vente ? {open: `/consultation/${success.err.vente.id}`, newTab: true, timeout: 5000} : {})
    else if(success?.err?.minEncError){
      if(success?.err?.minEncIsNumber == 1)
        alert.error(`Il faut au minimum ${Number(success?.err?.minEnc || 0).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH comme avance`)
      else
        alert.error(`Il faut au minimum ${Number(success?.err?.minEncTotal || 0).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH (${Number(success?.err?.minEnc || 0)}%) comme avance`)
    }
    else if(success?.err?.encCM7Error){
      alert.error(`Il faut au minimum ${Number(success?.err?.minAllowed || 0).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH (${Number(success?.err?.percent || 0)}%) comme avance (pour ${Number(success?.err?.months || 0)} mois)`)
    }
    else
      alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const callback2 = (success) => {
    if(success?.vente && !success.err){
      setReEnable(true);
      setModal(false);
      clearAll();
      if(alert.removeAll && typeof alert.removeAll === "function")
        alert.removeAll()
      alert.success("Vente validée", {open: `/consultation/${success.vente.id}`, timeout: 0});

      if(success.file){
        setPreviewBase64({file: success.file, fileName: success.fileName});
        setDocumentModal(true)
      }
      else
        alert.error("Erreur au niveau de création du reçu de vente")
      return
    }
    else
      alert.error("Une erreur s'est produite (3)");
    setDisableSubmit(false);
  }

  const callback_ = (success) => {
    if(success?.vente && !success.err){
      setReEnable(true);
      setModal(false);
      clearAll();
      if(alert.removeAll && typeof alert.removeAll === "function")
        alert.removeAll()
      alert.success("Vente validée", {open: `/consultation/${success.vente.id}`, timeout: 0});

      if(success.file){
        setPreviewBase64({file: success.file, fileName: success.fileName});
        setDocumentModal(true)
      }
      else
        alert.error("Erreur au niveau de création du reçu de vente")
      return
    }
    if(success?.err?.encExists)
      alert.error("Encaissement(s) déjà saisi(s), ici:", success.err.ventes?.length ? {open: `/consultation/${success.err.ventes[0].id}`, newTab: true, timeout: 5000} : {})
    else if(success?.err?.bienSold)
      alert.error("Bien déjà vendu, ici:", success.err.vente ? {open: `/consultation/${success.err.vente.id}`, newTab: true, timeout: 5000} : {})
    else if(success?.err?.minEncError){
      if(success?.err?.minEncIsNumber == 1)
        alert.error(`Il faut au minimum ${Number(success?.err?.minEnc || 0).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH comme avance`)
      else
        alert.error(`Il faut au minimum ${Number(success?.err?.minEncTotal || 0).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH (${Number(success?.err?.minEnc || 0)}%) comme avance`)
    }
    // else if(success?.err?.msg === "BIEN_SOLD")
    //   alert.error("Bien déjà vendu")
    else
      alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const confirmHandle = async (action) => {
    if(!action){
      alert.error(E_ERROR.NO_ACTION);
      return
    }
    if(!bien){
      alert.error("Veuillez choisir un bien");
      setTimeout(() => setActiveTab(constants.TAB_BIEN), 500);
      return
    }
    if(table_clients.length === 0){
      alert.error("Veuillez sélectionner au moins un client");
      setTimeout(() => setActiveTab(constants.TAB_CLIENT), 500);
      return
    }
    if(encaissements.length === 0){
      alert.error("Veuillez saisir au moins un encaissement");
      setTimeout(() => setActiveTab(constants.TAB_ENCAISSEMENT), 500);
      return
    }
    if(!selectedProjet || selectedProjet === ''){
      alert.error("Veuillez sélectionner un projet");
      return
    }
    if(!userValue || userValue === ''){
      alert.error("Veuillez sélectionner le commercial");
      return
    }
    if(numDossier === ''){
      alert.error("Veuillez saisir un N° de dossier");
      return
    }
    if(dateVente === ''){
      alert.error("Veuillez sélectionner une date valide");
      return
    }
    if(!((prixAafficherTotalValue && prixAafficherValue >= bien.PRIX_VENTE && prixAafficherValue < bien.PRIX_VENTE * 10)
    || (!prixAafficherTotalValue && (!bien.PRIX_M || (prixAafficherValue >= bien.PRIX_M && prixAafficherValue < bien.PRIX_M * 10))))){
      alert.error("Veuillez saisir un prix client supérieur du prix de vente");
      return
    }
    if(isAssociation){
      if(!association){
        alert.error("Veuillez saisir les informations de l'association");
        return
      }
      if(!association.selectedFloor || association.ETAGE === undefined){
        alert.error("Veuillez sélectionner un étage");
        return
      }
      if(association.TYPE === undefined){
        alert.error("Veuillez sélectionner le type de l'association");
        return
      }
      if(!association.POURCENTAGE){
        alert.error("Veuillez sélectionner un pourcentage");
        return
      }
      if(!association.PRIX_VENTE){
        alert.error("Veuillez saisir le prix de vente de l'association");
        return
      }
      if(association.PRIX_VENTE < (Number(association.selectedFloor?.totalPrice || 0) * association.POURCENTAGE) / 100){
        alert.error(`Prix de part est inférieur à ${association.POURCENTAGE}% du prix de l'étage (${((Number(association.selectedFloor?.totalPrice || 0) * association.POURCENTAGE) / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)`);
        return
      }
    }

    const totalEnc = encaissements.reduce((e, t) => e + Number(t.PART || 0), 0)
    const totalPrix = Number((isAssociation ? association?.PRIX_VENTE : bien?.PRIX_VENTE) || 0)
    // if(bien?.IDPROJET === 15 && (bien?.TYPE === "FB R+3 Com" || bien?.TYPE === "R+2 Com") && !isAssociation){
    // if(!isAssociation){
      // if(!bien.allow30){
      //   if(bien?.IDPROJET === 15 && bien?.TYPE === "R+2 Hab"){
      //     if(totalEnc < 100000){
      //       alert.error(`Il faut au minimum 100 000 DH comme avance`)
      //       return
      //     }
      //   }
      //   else if(bien?.IDPROJET === 15 && bien?.N && Number(bien.N || 0) == 1419){
      //     if(totalEnc < totalPrix * .25){
      //       alert.error(`Il faut au minimum 25% du prix du bien, soit: ${(totalPrix * .25).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH`)
      //       return
      //     }
      //   }
      //   else if((bien?.IDPROJET === 14 && (bien?.N == "313" || bien?.N == "307" || bien?.N == "282" || bien?.N == "245" || bien?.N == "276"))
      //        || (bien?.IDPROJET === 15 && bien?.N && Number(bien.N || 0) >= 1417 && Number(bien.N || 0) <= 1438)
      //        || (bien?.IDPROJET === 16 && (bien?.TYPE === "R+2 COM" || bien?.TYPE === "Villa"))){
      //     if(totalEnc < totalPrix * .5){
      //       alert.error(`Il faut au minimum 50% du prix du bien, soit: ${(totalPrix * .5).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH`)
      //       return
      //     }
      //   }
      //   else if(totalEnc < totalPrix * .3){
      //     alert.error(`Il faut au minimum 30% du prix du bien, soit: ${(totalPrix * .3).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH`)
      //     return
      //   }
      // }
    // }

    // const da : IAssociation = {
    //   IDCHANTIER: selectedValue["id"],
    //   IDDEPOT: selectedValue["id"],
    //   SAISIE_PAR: auth?.user && auth?.user.username ? auth?.user.username : undefined,
    //   OBSERVATION: observationValue,
    //   IDUSERS: auth?.user && auth?.user.id ? auth?.user.id : undefined,
    // };

    const remiseTemp = remiseTotalValue ? remiseValue : (remiseValue * (bien.SUPERFICIE || 0));
    const prixClientTemp = prixAafficherTotalValue ? prixAafficherValue : bien.SUPERFICIE ? (prixAafficherValue * bien.SUPERFICIE) : bien.PRIX_VENTE;

    const vente: IVente = isAssociation && bien.contrat ? {
      // hasPermission: true,
      ...bien.contrat,
      hasPermission: bien.hasPermission,
      // clients: [...[].concat(...(bien.contrat.associations?.map(e => [].concat(...e.contrat_clients.map(t => t.client))) || [])), ...table_clients],
      // encaissements: [...[].concat(...(bien.contrat.associations?.map(e => [].concat(...e.contrat_encaissements.map(t => ({...t.encaissement, contrat_encaissement: t, bank: banks.find(n => n.id === t.encaissement?.IDBANQUE)})))) || [])), ...encaissements.map(e => ({...e, bank: banks.find(t => t.id === e.IDBANQUE)}))],
      clients: [...[].concat(...(bien.contrat.associations?.map(e => [].concat(...(e.contrat_clients || []).map(t => t.client))) || [])), ...table_clients],
      encaissements: [...[].concat(...(bien.contrat.associations?.map(e => [].concat(...(e.contrat_encaissements || []).map(t => ({...t.encaissement, ...t, bank: banks.find(n => n.id === t.encaissement?.IDBANQUE)})))) || [])), ...encaissements.map(e => ({...e, bank: banks.find(t => t.id === e.IDBANQUE)}))],
      contrat_encaissements: [...[].concat(...(bien.contrat.associations?.map(e => [].concat(...(e.contrat_encaissements || []).map(t => ({...t.encaissement, ...t, bank: banks.find(n => n.id === t.encaissement?.IDBANQUE)})))) || [])), ...encaissements.map(e => ({...e, encaissement: e, bank: banks.find(t => t.id === e.IDBANQUE)}))],
      // encaissements: encaissements.map(e => ({...e, bank: banks.find(t => t.id === e.IDBANQUE)}))
    } : {
      // hasPermission: true,
      bien,
      hasPermission: bien.hasPermission,
      clients: table_clients,
      encaissements: encaissements.map(e => ({...e, bank: banks.find(t => t.id === e.IDBANQUE)})),
      PROJET: selectedProjet["LIBELE"],
      IDPROJET: selectedProjet["id"],
      NUM_DOSS: numDossier,
      DATE_RESERV: new Date(dateVente),
      ID_BIEN: bien.id,
      DESIGNATION: bien.DESIGNATION,
      TRANCHE: bien.TRANCHE,
      IMMEUBLE: bien.IMMEUBLE,
      N: bien.N,
      SUPERFICIE: bien.SUPERFICIE,
      ETAGE: bien.ETAGE,
      POSITION: bien.POSITION,
      TYPE: bien.TYPE,
      ORIENTATION: bien.ORIENTATION,
      TYPE_VENTE: isAssociation ? "ASSOCIATION" : "UNIQUE",
      PRIX_M_BIEN: bien.PRIX_M,
      PRIX_M: bien.SUPERFICIE ? prixClientTemp / bien.SUPERFICIE : bien.PRIX_M,
      PRIX_BIEN: bien.PRIX_VENTE,
      PRIX_NET: prixClientTemp,
      MAC: bien.MAC,
      REMISE_VALIDEE: -1,
      OBSERVATION: observation,
      ID_COM: userValue["id"],
      SAISIE_PAR: userValue["username"],
      REMISE: remiseTemp,
      PRIX_M_CLIENT: prixClientTemp
    };
    if(action === CHECK){
      setModal(true);
      return
    }
    else if(action === CONFIRM){
      setDisableSubmit(true);
      const recu_image_counter = await getConstanteRecuImageIncrem();
      let uploads: any[] = [],
        uploadCount = 0;

      for(let i in encaissements){
        if(!encaissements[i].partFrom){
          uploadCount++;
          if(encaissements[i].verso)
            uploadCount++
        }
      }

      const uploadCallback = () => {
        if(uploads.length === uploadCount){
          if(auth?.user)
            auth.user.last_societe = selectedProjet["id"]
          addVente(isAssociation ? 1 : 0, bien, isAssociation && bien?.contrat ? bien.contrat : undefined, table_clients, encaissements/*, recuFile*/, recu_image_counter, uploads, association, selectedProjet["id"], selectedProjet["LIBELE"], numDossier, new Date(dateVente), bien.SUPERFICIE ? prixClientTemp / bien.SUPERFICIE : bien.PRIX_M, prixClientTemp, observation, auth?.user && auth?.user.id ? auth?.user.id : undefined, auth?.user && auth?.user.username ? auth?.user.username : undefined, userValue["id"], userValue["username"], remiseTotalValue ? remiseValue : (remiseValue * bien.SUPERFICIE), prixAafficherTotalValue ? prixAafficherValue : (prixAafficherValue * bien.SUPERFICIE), callback1);
        }
      }

      if(uploadCount === 0)
        uploadCallback()
      else{
        const setCodedBuffer = (blob, name, isVerso) => {
          var reader = new FileReader();
          reader.onload = function() {
            var arrayBuffer = this.result,
              codedBuffer: string = "";
            (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
                codedBuffer += String.fromCharCode(byte);
            });
            uploads.push({codedBuffer, name, isVerso});
            uploadCallback();
          }
          reader.readAsArrayBuffer(blob);
        };

        for(let i in encaissements){
          if(!encaissements[i].partFrom){
            setCodedBuffer(encaissements[i].recto, encaissements[i].REF_REGLEMENT, false);
            if(encaissements[i].verso)
              setCodedBuffer(encaissements[i].verso, encaissements[i].REF_REGLEMENT, true);
          }
        }
      }
      // addVente(isAssociation ? 1 : 0, bien, clients, encaissements, association, projet, numDossier, new Date(dateVente), observation, userValue["id"], userValue["username"], callback);
      // addVente(bien, clients, encaissements, projet, numDossier, new Date(dateVente), observation, auth?.user && auth?.user.id ? auth?.user.id : -1, auth?.user && auth?.user.username ? auth?.user.username : "", callback);
      return
    }
    // return {...da, da_articles: dalinesData.map(e => ({CODE_PRODUIT: e.CODE_PRODUIT, DESIGNATION: e.LIBELLE, QTE_INIT: e.quantite, UNITE: e.UNITE, DATE_LIVRAISON: e.DATE_LIVRAISON})), chantier: selectedValue, createdAt: new Date()}
    return vente
  }
  
  return (
    <>
      <Container className="confirmDiv" fixed="down">
        {bien ? <Container className="venteFloatingPrices">
          <Row>
            <Col xs="12" md="6" className="text-center text-md-right">
              <strong>Prix Net : </strong>
            </Col>
            <Col xs="12" md="6" className="text-center text-md-left">
              {bien ? (prixBien.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ` Dh${remiseE ? ` (dont une remise de ${remiseE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh du total)` : ""}`) : <span className="divSpanAsLinkContent" onClick={switchToBien || function(e){}} title="Basculer à l'onglet des biens"><FontAwesomeIcon icon={faBuilding} />&nbsp;<span>Sélectionner un bien</span></span>}
            </Col>
          </Row>
          <Row>
            <Col xs="12" md="6" className="text-center text-md-right">
              <strong>Total des encaissements : </strong>
            </Col>
            <Col xs="12" md="6" className="text-center text-md-left">
              <strong>{totalEncaissements.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh"}</strong> {prixBien ? <span className="encPercent" style={{color: "hsl(" + (Math.ceil((totalEncaissements * 100) / prixBien) * 1.2).toString(10) + ", 100%, 50%)"}}>({Math.ceil((totalEncaissements * 100) / prixBien)}%)</span> : null}
            </Col>
          </Row>
          <Row>
            <Col xs="12" md="6" className="text-center text-md-right">
              <strong>Montant restant à payer : </strong>
            </Col>
            <Col xs="12" md="6" className="text-center text-md-left" style={bien && reliquat < 0 ? {color: "red"} : {}}>
              {bien ? (reliquat.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
            </Col>
          </Row>
        </Container> : null}
        <Row className="justify-content-center">
          <Col xs="12" md="3" lg="2">
            <FormGroup>
              <PDFLink documentType={"vente"}
                download={false}
                style={{backgroundColor: "#a1c45c", borderColor: "#a1c45c44"}}
                func={async () => confirmHandle(PREVIEW)} />
                {/* columns={[{value: 'Désignation', width: 70}, {value: 'Qte', width: 15}, {value: 'Unité', width: 15}]} /> */}
            </FormGroup>
          </Col>
          <Col xs="12" md="6">
            <FormGroup>
              <Button
                // color="info"
                className="btnA confirmBtn"
                onClick={() => confirmHandle(CHECK)}
                ><FontAwesomeIcon icon={faCheckCircle} />&nbsp;&nbsp;Valider la vente</Button>
            </FormGroup>
          </Col>
        </Row>
      </Container>

      <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;Confirmation</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer">
            <Row className="linesConfirmationRow">
              Voulez-vous vraiment valider la vente ?
            </Row>
            {/* {dalinesData.map((e, key) => (
              <Row className="linesConfirmationLines" key={key}>
                <Col xs="12"><b>{e.quantite}</b>{e.UNITE && ["u", "un", "unite", "unité"].includes(e.UNITE.toLowerCase()) ? " x " : <b>&nbsp;{e.UNITE}&nbsp;</b>}{`[${e.CODE_PRODUIT}] ${e.LIBELLE}`}</Col>
                <Col xs="12"><b>Date de livraison</b> : {moment(e.DATE_LIVRAISON).format('DD/MM/YYYY')}</Col>
              </Row>
            ))} */}
            <Row className="justify-content-center">
              <Button
                className="btnA confirmBtn linesConfirmationBtn linesDeleteBtn"
                onClick={() => confirmHandle(CONFIRM)}
                disabled={disableSubmit}
                ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Confirmer et Imprimer le Reçu</Button>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
      <PreviewBase64 base64={previewBase64.file} fileName={previewBase64.fileName} modal={documentModal} setModal={setDocumentModal} />
      </>
  );
};

const mapStateToProps = (state: IConfirmVenteReduxProps) => ({
  client: state.client,
  bank: state.bank,
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { addVente, getBanks })(ConfirmVente);
